module.exports = __webpack_public_path__ + "static/media/red_v2.6fe3efd9.jpg";